import React, { useEffect, useMemo, useState } from "react";
import Moment from "react-moment";
import AddPartnerUser from "./AddPartnerUser";
import ActiveDeactiveHistory from "./ActiveDeactiveHistory";
import { useDispatch, useSelector } from "react-redux";
import { getPartnerUsers, loadPartnerUsers } from "../../app/store/partner";
import { getCurrentUser, getLoggedUserDetails, loadUserDetails } from "../../app/store/auth";
import { getFormatedNumber } from "../../Services/appService";
import { setCurrentPageTitle, setCurrentRoute } from "../../app/store/layoutUI";
import { getAlert } from "../../Services/appAlerts";
import AddEditPermission from "./AddEditPermission";

const MANAGE_USERS_STYLES = {
  shell: {
    display: "flex",
    flexDirection: "column",
    gap: "18px"
  },
  hero: {
    borderRadius: "24px",
    padding: "22px 24px",
    border: "1px solid rgba(191, 219, 254, 0.95)",
    background: "linear-gradient(135deg, #eff6ff 0%, #ffffff 58%, #f8fafc 100%)",
    boxShadow: "0 18px 40px rgba(37, 99, 235, 0.08)"
  },
  heroRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "18px",
    flexWrap: "wrap"
  },
  heroCopy: {
    minWidth: "260px",
    flex: 1
  },
  eyebrow: {
    fontSize: "11px",
    fontWeight: 800,
    letterSpacing: "0.16em",
    textTransform: "uppercase",
    color: "#2563eb",
    marginBottom: "10px"
  },
  heroTitle: {
    fontSize: "30px",
    fontWeight: 800,
    lineHeight: 1.08,
    color: "#0f172a",
    margin: "0 0 10px 0"
  },
  heroText: {
    fontSize: "14px",
    lineHeight: 1.65,
    color: "#475569",
    margin: 0,
    maxWidth: "760px"
  },
  heroAction: {
    borderRadius: "999px",
    padding: "10px 16px",
    fontWeight: 700,
    boxShadow: "0 10px 24px rgba(15, 23, 42, 0.08)"
  },
  statGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: "14px",
    marginTop: "18px"
  },
  statCard: {
    backgroundColor: "#ffffff",
    border: "1px solid rgba(219, 234, 254, 1)",
    borderRadius: "18px",
    padding: "16px 18px",
    boxShadow: "0 10px 22px rgba(37, 99, 235, 0.06)"
  },
  statLabel: {
    fontSize: "11px",
    fontWeight: 800,
    letterSpacing: "0.12em",
    textTransform: "uppercase",
    color: "#64748b",
    marginBottom: "10px"
  },
  statValue: {
    fontSize: "28px",
    fontWeight: 800,
    lineHeight: 1,
    color: "#0f172a",
    marginBottom: "6px"
  },
  statText: {
    fontSize: "13px",
    color: "#64748b",
    lineHeight: 1.5
  },
  panel: {
    backgroundColor: "#ffffff",
    border: "1px solid rgba(226, 232, 240, 1)",
    borderRadius: "22px",
    boxShadow: "0 12px 30px rgba(15, 23, 42, 0.05)",
    overflow: "hidden"
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "14px",
    padding: "18px 20px 0 20px",
    flexWrap: "wrap"
  },
  toolbarCopy: {
    minWidth: "240px",
    flex: 1
  },
  panelTitle: {
    fontSize: "20px",
    fontWeight: 800,
    color: "#0f172a",
    margin: "0 0 6px 0"
  },
  panelText: {
    fontSize: "13px",
    color: "#64748b",
    margin: 0
  },
  filterRow: {
    display: "flex",
    gap: "10px",
    flexWrap: "wrap"
  },
  input: {
    minWidth: "230px",
    borderRadius: "12px",
    border: "1px solid rgba(203, 213, 225, 1)",
    padding: "10px 12px",
    fontSize: "13px",
    color: "#0f172a",
    outline: "none",
    backgroundColor: "#ffffff"
  },
  select: {
    minWidth: "160px",
    borderRadius: "12px",
    border: "1px solid rgba(203, 213, 225, 1)",
    padding: "10px 12px",
    fontSize: "13px",
    color: "#0f172a",
    outline: "none",
    backgroundColor: "#ffffff"
  },
  tableWrap: {
    padding: "16px 20px 20px 20px"
  },
  table: {
    marginBottom: 0,
    borderCollapse: "separate",
    borderSpacing: 0
  },
  statusPill: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    padding: "6px 10px",
    borderRadius: "999px",
    fontSize: "12px",
    fontWeight: 700,
    border: "1px solid transparent"
  },
  rolePill: {
    display: "inline-flex",
    alignItems: "center",
    padding: "6px 10px",
    borderRadius: "999px",
    backgroundColor: "#eff6ff",
    border: "1px solid rgba(191, 219, 254, 1)",
    color: "#1d4ed8",
    fontSize: "12px",
    fontWeight: 700
  },
  userName: {
    fontSize: "14px",
    fontWeight: 700,
    color: "#0f172a",
    marginBottom: "4px"
  },
  userMeta: {
    fontSize: "12px",
    lineHeight: 1.55,
    color: "#64748b"
  },
  actionLink: {
    border: "none",
    background: "transparent",
    color: "#2563eb",
    padding: 0,
    fontSize: "12px",
    fontWeight: 700
  },
  mutedAction: {
    fontSize: "12px",
    color: "#94a3b8",
    fontWeight: 600
  },
  emptyState: {
    padding: "28px 20px 30px 20px",
    textAlign: "center",
    color: "#64748b",
    fontSize: "14px"
  }
};

const ManagePartnerUsers = () => {
  const route = [{ name: "Administration", url: "/" }];

  const [userList, setUserList] = useState([]);
  const [actionType, setActionType] = useState("action");
  const [userDetails, setUserDetails] = useState(null);
  const [logShowHide, setLogShowHide] = useState(false);
  const [showHide, setShowHide] = useState(false);
  const [permissionShowHide, setPermissionShowHide] = useState(false);
  const [selectedObj, setSelectedObj] = useState("");
  const [selectedId, setSelectedId] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");

  const userDetailsSelector = useSelector(getLoggedUserDetails);
  const partnerUsersSelector = useSelector(getPartnerUsers);


  const currentUser = getCurrentUser();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setCurrentPageTitle("Manage Users"));
    dispatch(setCurrentRoute(route))
  }, [])

  useEffect(() => {
    if (!userDetailsSelector)
      dispatch(loadUserDetails(currentUser.id));
  }, []);

  useEffect(() => {
    if (userDetailsSelector && userDetailsSelector?.partnerid) {
      setUserDetails(userDetailsSelector);
      dispatch(loadPartnerUsers(userDetailsSelector.partnerid))
    }
  }, [userDetailsSelector]);

  useEffect(() => {
    setUserList(partnerUsersSelector);
  }, [partnerUsersSelector]);

  const filteredUsers = useMemo(() => {
    const normalizedSearch = searchTerm.trim().toLowerCase();

    return userList.filter((item) => {
      const matchesSearch =
        normalizedSearch === "" ||
        `${item.name || ""} ${item.lastName || ""}`.toLowerCase().includes(normalizedSearch) ||
        (item.email || "").toLowerCase().includes(normalizedSearch) ||
        (item.title || "").toLowerCase().includes(normalizedSearch) ||
        String(item.id || "").includes(normalizedSearch) ||
        (item.state || "").toLowerCase().includes(normalizedSearch);

      const matchesStatus =
        statusFilter === "all" ||
        (statusFilter === "active" && item.status === true) ||
        (statusFilter === "inactive" && item.status === false) ||
        (statusFilter === "pending" && item.status !== true && item.status !== false);

      return matchesSearch && matchesStatus;
    });
  }, [userList, searchTerm, statusFilter]);

  const activeUsersCount = userList.filter((item) => item.status === true).length;
  const inactiveUsersCount = userList.filter((item) => item.status === false).length;
  const pendingUsersCount = userList.filter((item) => item.status !== true && item.status !== false).length;

  const handleModalShowHide = (obj) => {
    if (obj === "save") {
      setShowHide(false);
      setSelectedObj("");
      if (userDetails)
        dispatch(loadPartnerUsers(userDetails.partnerid))
    } else {
      setShowHide(!showHide);
      setSelectedObj(obj);
    }
  };

  const handlePermission = (item) => {
    setSelectedId(item.id)
    setPermissionShowHide(true);
  }

  const handlePermissionShowHide = () => {
    setSelectedId("")
    setPermissionShowHide(false)
    // setSelectedObj(null);
    // setSelectedKey("home");
    getAlert("", "Permissions Updated Successfully", "success");
  };

  const handlePermissionModalShowHide = () => {
    setSelectedId("")
    setPermissionShowHide(prev => !prev)
  };

  const handleLogShowHide = (item, type) => {
    if (item === "save") {
      setLogShowHide(false);
      setSelectedObj("");
      setActionType("action");
      if (userDetails)
        dispatch(loadPartnerUsers(userDetails.partnerid))
    } else {
      setLogShowHide(!logShowHide);
      setSelectedObj(item);
      setActionType(type);
    }
  };

  const getStatusStyles = (status) => {
    if (status === true) {
      return {
        ...MANAGE_USERS_STYLES.statusPill,
        color: "#166534",
        backgroundColor: "#f0fdf4",
        borderColor: "rgba(187, 247, 208, 1)"
      };
    }

    if (status === false) {
      return {
        ...MANAGE_USERS_STYLES.statusPill,
        color: "#b91c1c",
        backgroundColor: "#fef2f2",
        borderColor: "rgba(254, 202, 202, 1)"
      };
    }

    return {
      ...MANAGE_USERS_STYLES.statusPill,
      color: "#92400e",
      backgroundColor: "#fffbeb",
      borderColor: "rgba(253, 230, 138, 1)"
    };
  };

  return (
    <React.Fragment>
      <style>{`
        .manage-users-table thead th {
          font-size: 11px;
          font-weight: 800;
          letter-spacing: 0.08em;
          text-transform: uppercase;
          color: #64748b;
          background: #f8fafc;
          border-bottom: 1px solid rgba(226, 232, 240, 1);
          padding-top: 14px;
          padding-bottom: 14px;
        }

        .manage-users-table tbody td {
          padding-top: 14px;
          padding-bottom: 14px;
          vertical-align: middle;
          border-top: 1px solid rgba(241, 245, 249, 1);
        }

        .manage-users-table tbody tr:hover {
          background-color: #fbfdff;
        }
      `}</style>

      <div style={MANAGE_USERS_STYLES.shell}>
        <div style={MANAGE_USERS_STYLES.hero}>
          <div style={MANAGE_USERS_STYLES.heroRow}>
            <div style={MANAGE_USERS_STYLES.heroCopy}>
              <div style={MANAGE_USERS_STYLES.eyebrow}>Administration</div>
              <h1 style={MANAGE_USERS_STYLES.heroTitle}>Manage Partner Users</h1>
              <p style={MANAGE_USERS_STYLES.heroText}>
                Review account access, monitor activation status, edit user records, and manage permissions from one workspace.
              </p>
            </div>

            <button
              className="btn btn-primary"
              style={MANAGE_USERS_STYLES.heroAction}
              onClick={() => handleModalShowHide("")}
            >
              <i className="fa fa-user-plus mr-2"></i>
              Add User
            </button>
          </div>

          <div style={MANAGE_USERS_STYLES.statGrid}>
            <div style={MANAGE_USERS_STYLES.statCard}>
              <div style={MANAGE_USERS_STYLES.statLabel}>Total Users</div>
              <div style={MANAGE_USERS_STYLES.statValue}>{userList.length}</div>
              <div style={MANAGE_USERS_STYLES.statText}>All partner users currently available in this workspace.</div>
            </div>
            <div style={MANAGE_USERS_STYLES.statCard}>
              <div style={MANAGE_USERS_STYLES.statLabel}>Active</div>
              <div style={MANAGE_USERS_STYLES.statValue}>{activeUsersCount}</div>
              <div style={MANAGE_USERS_STYLES.statText}>Users who can currently access partner tools.</div>
            </div>
            <div style={MANAGE_USERS_STYLES.statCard}>
              <div style={MANAGE_USERS_STYLES.statLabel}>Inactive</div>
              <div style={MANAGE_USERS_STYLES.statValue}>{inactiveUsersCount}</div>
              <div style={MANAGE_USERS_STYLES.statText}>Users that are currently deactivated.</div>
            </div>
            <div style={MANAGE_USERS_STYLES.statCard}>
              <div style={MANAGE_USERS_STYLES.statLabel}>Pending</div>
              <div style={MANAGE_USERS_STYLES.statValue}>{pendingUsersCount}</div>
              <div style={MANAGE_USERS_STYLES.statText}>Users waiting for an activation decision.</div>
            </div>
          </div>
        </div>

        <div style={MANAGE_USERS_STYLES.panel}>
          <div style={MANAGE_USERS_STYLES.toolbar}>
            <div style={MANAGE_USERS_STYLES.toolbarCopy}>
              <h2 style={MANAGE_USERS_STYLES.panelTitle}>Users Directory</h2>
              <p style={MANAGE_USERS_STYLES.panelText}>
                Search, filter, and manage partner users without leaving the table.
              </p>
            </div>

            <div style={MANAGE_USERS_STYLES.filterRow}>
              <input
                type="text"
                placeholder="Search by name, email, ID, role, or state"
                value={searchTerm}
                onChange={(event) => setSearchTerm(event.target.value)}
                style={MANAGE_USERS_STYLES.input}
              />
              <select
                value={statusFilter}
                onChange={(event) => setStatusFilter(event.target.value)}
                style={MANAGE_USERS_STYLES.select}
              >
                <option value="all">All statuses</option>
                <option value="active">Activated</option>
                <option value="inactive">Deactivated</option>
                <option value="pending">Pending</option>
              </select>
            </div>
          </div>

          <div style={MANAGE_USERS_STYLES.tableWrap}>
            <div className="table-responsive">
              <table className="table manage-users-table" style={MANAGE_USERS_STYLES.table}>
                <thead className="thead-light">
                  <tr>
                    <th>ID</th>
                    <th>Date & Time</th>
                    <th>User Details</th>
                    <th>Role</th>
                    <th>State</th>
                    <th>Status</th>
                    <th>Action</th>
                    <th>Permission</th>
                  </tr>
                </thead>

                <tbody>
                  {filteredUsers.map((item) => {
                    const isCurrentUser = userDetails?.performername === item.name;

                    const renderStatus = () => {
                      const iconStyle = { fontSize: "15px" };

                      if (item.status === true) {
                        return (
                          <>
                            <i className="fa fa-check" style={iconStyle}></i> Activated
                          </>
                        );
                      }

                      if (item.status === false) {
                        return (
                          <>
                            <i className="fa fa-times" style={iconStyle}></i> Deactivated
                          </>
                        );
                      }

                      return (
                        <>
                          <i className="fa fa-clock-o" style={iconStyle}></i> To Activate
                        </>
                      );
                    };

                    const renderStatusCell = () => {
                      if (isCurrentUser) {
                        return <span style={getStatusStyles(item.status)}>{renderStatus()}</span>;
                      }

                      return (
                        <button
                          className="btn btn-link btn-sm p-0"
                          onClick={() => handleLogShowHide(item, "action")}
                          style={getStatusStyles(item.status)}
                        >
                          {renderStatus()}
                        </button>
                      );
                    };

                    return (
                      <tr key={item.id}>
                        <td>{item.id}</td>

                        <td>
                          <div style={MANAGE_USERS_STYLES.userName}>
                            <Moment format="MMM Do YYYY">{item.addedDateTime}</Moment>
                          </div>
                          <div style={MANAGE_USERS_STYLES.userMeta}>
                            <Moment format="h:mm a">{item.addedDateTime}</Moment>
                          </div>
                        </td>

                        <td>
                          <div style={MANAGE_USERS_STYLES.userName}>
                            {item.name} {item.lastName}
                          </div>
                          <div style={MANAGE_USERS_STYLES.userMeta}>{item.email}</div>
                          <div style={MANAGE_USERS_STYLES.userMeta}>
                            {item.contact ? getFormatedNumber(item.contact) : "No phone on file"}
                          </div>
                        </td>

                        <td>
                          <span style={MANAGE_USERS_STYLES.rolePill}>{item.title || "User"}</span>
                        </td>
                        <td>{item.state || "-"}</td>

                        <td>{renderStatusCell()}</td>

                        <td>
                          <button
                            type="button"
                            className="btn btn-link btn-sm p-0"
                            title="Edit User"
                            onClick={() => handleModalShowHide(item)}
                            style={MANAGE_USERS_STYLES.actionLink}
                          >
                            Edit User
                          </button>
                        </td>

                        <td>
                          {!isCurrentUser && (
                            <button
                              type="button"
                              className="btn btn-link btn-sm p-0"
                              onClick={() => handlePermission(item)}
                              style={MANAGE_USERS_STYLES.actionLink}
                            >
                              Add/Edit Permission
                            </button>
                          )}
                          {isCurrentUser && (
                            <span style={MANAGE_USERS_STYLES.mutedAction}>Current user</span>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                  {filteredUsers.length === 0 && (
                    <tr>
                      <td colSpan="8" style={MANAGE_USERS_STYLES.emptyState}>
                        No users matched the current search or status filter.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      {
        selectedId &&
        <AddEditPermission
          roleid={selectedId}
          roleSource="partner"
          handlePermissionShowHide={handlePermissionShowHide}
          showHide={permissionShowHide}
          handleModalShowHide={handlePermissionModalShowHide}
        />
      }
      <AddPartnerUser
        showHide={showHide}
        handleModalShowHide={handleModalShowHide}
        currentUser={currentUser}
        selectedObj={selectedObj}
        userDetails={userDetails}
      ></AddPartnerUser>
      <ActiveDeactiveHistory
        logShowHide={logShowHide}
        handleLogShowHide={handleLogShowHide}
        selectedObj={selectedObj}
        type="performer"
        pageType="User"
        actionType={actionType}
      ></ActiveDeactiveHistory>
    </React.Fragment>
  );
}

export default ManagePartnerUsers;
